module.exports = __webpack_public_path__ + "static/media/logo.e97cf774.png";